import {useEffect} from 'react'
import {useLocation} from '@remix-run/react'

export default function ScrollToHash() {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash)
      if (element) {
        const offset = 100
        const elementPosition = element.getBoundingClientRect().top + window.scrollY
        window.scrollTo({top: elementPosition - offset, behavior: 'smooth'})
      }
    }
  }, [location])

  return null
}
